import script from "./form-plan-price.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-plan-price.vue?vue&type=script&setup=true&lang=ts"

import "./form-plan-price.vue?vue&type=style&index=0&id=25e5d3c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e5d3c8"]])

export default __exports__